(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tdet-footer-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tdet-footer-v2')) {
  customElements.define('tdet-footer-v2', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.menus = [...this.querySelectorAll('details.tf-menu')];
      this.mobile = undefined;
      const resize = width => {
        const mobile = width <= 600;
        if (mobile === this.mobile) return;
        this.mobile = mobile;
        this.menus.forEach(menu => { menu.open = !mobile || menu.dataset.openMobile === 'true' || menu.hasAttribute('data-editor-selected'); });
      };
      const container = this.querySelector('.tf-footer');
      resize(container.getBoundingClientRect().width);
      this.observer = new ResizeObserver(entries => resize(entries[0].contentRect.width));
      this.observer.observe(container);
      this.menus.forEach(menu => menu.querySelector('summary').addEventListener('click', event => {
        if (!this.mobile || menu.hasAttribute('data-editor-selected')) event.preventDefault();
      }, { signal }));
      this.addEventListener('shopify:block:select', event => {
        const menu = event.target.closest('details.tf-menu');
        if (menu && this.contains(menu)) { menu.setAttribute('data-editor-selected', ''); menu.open = true; }
      }, { signal });
      this.addEventListener('shopify:block:deselect', event => {
        const menu = event.target.closest('details.tf-menu');
        if (menu && this.contains(menu)) { menu.removeAttribute('data-editor-selected'); menu.open = !this.mobile || menu.dataset.openMobile === 'true'; }
      }, { signal });
      const cookies = this.querySelector('.tf-cookies');
      if (cookies) {
        cookies.hidden = false;
        cookies.addEventListener('click', async () => {
          const status = this.querySelector('.tf-cookies-status');
          status.textContent = '';
          try {
            if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Preferences unavailable');
            await window.privacyBanner.showPreferences();
          } catch { status.textContent = this.dataset.cookiesError; }
        }, { signal });
      }
    }
    disconnectedCallback() { this.abortController?.abort(); this.observer?.disconnect(); }
  });
}


  } catch(e) { console.error(e); }
})();
})();
